import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { VendorFinalizationService } from '../../Services/job-allocation-to-vendors/vendor-finalization.service';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { Router, ActivatedRoute } from '@angular/router';
import { PagerService } from 'src/app/Services/pager.service';
import { VendorFinalizationDetails, VendorFinalizationFilters, UpdateVendorType, UpdateVendorTypeDetails } from '../../Models/job-allocation-to-vendors/vendor-finalization';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { element } from '@angular/core/src/render3/instructions';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vendor-finalization',
  templateUrl: './vendor-finalization.component.html',
  styleUrls: ['./vendor-finalization.component.css'],
  providers: [DatePipe]
})
export class VendorFinalizationComponent implements OnInit {
  userID: string;
  roleID: string;
  selectedJobNumber: any;
  selectedRMHName: any;
  selectedJobType: any;
  selectedBrand: any;
  selectedCrop: any;
  selectedLanguage: any;
  selectedStatus: any;
  selectedMonth: any;
  vendorFilters: VendorFinalizationFilters = new VendorFinalizationFilters();
  vendorDetails: VendorFinalizationDetails[] = [];
  mainVendorDetails: VendorFinalizationDetails[] = [];
  VendorFinalizationpopUp: VendorFinalizationDetails[] = [];
  loader: string = 'none';
  files: File[] = [];
  fileName: string = '';
  pageSetting: number = 10;
  pager: any = {};
  //model: any[];
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  selectedState: any;
  userName: string;
  date = new Date();
  vendorTypeDetail: any[] = [];
  //multivendorTypeDetail: any[] = [];
  selectedVendor: any;
  selectedYear: any; 
  ascNumberSort: boolean = true;
  sortDirection: string = '';
  @ViewChild('file') input;
  @ViewChild('year') year;
  selected: number = 0;
  displayVendorAssignment: string = 'none';
  VendorJobNumber: string;
  vendorGridTypeDetail: UpdateVendorTypeDetails;
  vendorType: any;
  IsValidForDelete: string = 'none';
  displayViewAssesment: string = 'none';
  IsEdit:string='none';
  IsSave:string='block';
  editIndex:number=0;
  dropdownList = [
    { item_id: '1', item_text: 'Jan' },
    { item_id: '2', item_text: 'Feb' },
    { item_id: '3', item_text: 'Mar' },
    { item_id: '4', item_text: 'Apr' },
    { item_id: '5', item_text: 'May' },
    { item_id: '6', item_text: 'Jun' },
    { item_id: '7', item_text: 'Jul' },
    { item_id: '8', item_text: 'Aug' },
    { item_id: '9', item_text: 'Sep' },
    { item_id: '10', item_text: 'Oct' },
    { item_id: '11', item_text: 'Nov' },
    { item_id: '12', item_text: 'Dec' }
  ];
  dropdownSettings1: IDropdownSettings = {
    singleSelection: false,
    idField: 'jobNumberID',
    textField: 'jobNumberName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings2: IDropdownSettings = {
    singleSelection: false,
    idField: 'rMHCode',
    textField: 'rMHName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings3: IDropdownSettings = {
    singleSelection: false,
    idField: 'jobTypeID',
    textField: 'jobTypeName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings4: IDropdownSettings = {
    singleSelection: false,
    idField: 'cropID',
    textField: 'cropName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings5: IDropdownSettings = {
    singleSelection: false,
    idField: 'brandID',
    textField: 'brandName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings6: IDropdownSettings = {
    singleSelection: false,
    idField: 'languageID',
    textField: 'languageName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings7: IDropdownSettings = {
    singleSelection: false,
    idField: 'stateID',
    textField: 'stateName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings8: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings9: IDropdownSettings = {
    singleSelection: false,
    idField: 'vendorTypeID',
    textField: 'vendorType',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownVendorSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'vendorTypeID',
    textField: 'vendorType',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: false

  };
  yearSettings : IDropdownSettings = {
    singleSelection: true,
    idField: 'year',
    textField: 'year',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: false,
    limitSelection: -1,
    clearSearchFilter: false,
    itemsShowLimit: 1,
    searchPlaceholderText: 'Search',
    noDataAvailablePlaceholderText: 'No Year Found',
    closeDropDownOnSelection: false,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };


  constructor(private vendorFinalizationService: VendorFinalizationService, private snackBar: MatSnackBarComponent,
    private _pagerService: PagerService, private router: Router,  private datepipe: DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.userName = localStorage.getItem('mcmt_userName');
    this.displayVendorAssignment = 'none';
    this.VendorFinalizationpopUp = [];
    this.IsValidForDelete = 'none';
    this.displayViewAssesment = 'none';

  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.vendorFinalizationFilters();
    this.vendorTypes();

  }
  vendorFinalizationFilters() {
    this.loader = 'block';
    this.vendorFinalizationService.vendorFinalizationFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.vendorFilters = resData.data;
          class YearItemList{
            id: string;
            text: string;
        }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.vendorFilters.rollingYears[0].currentrequirementYear,
            text: this.vendorFilters.rollingYears[0].currentrequirementYear
          }
          requiredItem.push(obj)
          this.year.selectedItems = requiredItem;
          this.vendorFinalizationDetails();
          this.loader = 'none';

        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  vendorFinalizationDetails() {
    this.loader = 'block';
    this.selectedJobNumber = undefined;
    this.selectedRMHName = undefined;
    this.selectedJobType = undefined;
    this.selectedBrand = undefined;
    this.selectedCrop = undefined;
    this.selectedLanguage = undefined;
    this.selectedStatus = undefined;
    this.selectedMonth = undefined;
    this.selectedState = undefined;
    this.vendorFinalizationService.getVendorFinalization(this.selectedJobNumber, this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop,
      this.selectedLanguage, this.selectedStatus, this.selectedMonth, this.selectedState)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.vendorDetails = resdata.data;
          //this.model=resdata.data;
          this.mainVendorDetails = resdata.data
          // this.setPage(1,this.pageSetting)
          this.loader = 'none';
          this.filter();
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }

  vendorTypes() {
    this.loader = 'block';
    this.vendorFinalizationService.vendorTypes()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.vendorTypeDetail = resData.data.vendorTypes;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  excelDownload() {
    this.loader = 'block';
    let selectJobNo: any[] = this.selectedJobNumber;
    let selectRmh: any[] = this.selectedRMHName;
    let selectJob: any[] = this.selectedJobType;
    let selectBrand: any[] = this.selectedBrand;
    let selectCrop: any[] = this.selectedCrop;
    let selectLanguage: any[] = this.selectedLanguage;
    let selectStatus: any[] = this.selectedStatus;
    let selectMonth: any[] = this.selectedMonth;
    let selectState: any[] = this.selectedState;
    let selectedVendor: any[] = this.selectedVendor;
    let selectYear: any = this.year.selectedItems[0].id;
    let customJobNo: string = "";
    let customVendor: string = "";
    let customRmh: string = "";
    let customJob: string = "";
    let customBrand: string = "";
    let customCrop: string = "";
    let customLanguage: string = "";
    let customStatus: string = "";
    let customMonth: string = "";
    let customState: string = "";
    let customYear: string = "";
    if (selectJobNo != undefined) {
      selectJobNo.forEach(x => {
        if (x.length == 0) {
          customJobNo = "";
        }
        else {
          if (customJobNo == "") {
            customJobNo = x.jobNumberName;
          }
          else {
            customJobNo = customJobNo.concat(",");
            customJobNo = customJobNo.concat(x.jobNumberName);
          }
        }
      })
    }
    if (selectYear != undefined) {
      customYear = selectYear;
    }
    if (selectedVendor != undefined) {
      selectedVendor.forEach(x => {
        if (x.length == 0) {
          customVendor = "";
        }
        else {
          if (customVendor == "") {
            customVendor = x.vendorType;
          }
          else {
            customVendor = customVendor.concat(",");
            customVendor = customVendor.concat(x.vendorType);
          }
        }
      })
    }
    if (selectRmh != undefined) {
      selectRmh.forEach(x => {
        if (x.length == 0) {
          customRmh = "";
        }
        else {
          if (customRmh == "") {
            customRmh = x.rMHCode;
          }
          else {
            customRmh = customRmh.concat(",");
            customRmh = customRmh.concat(x.rMHCode);
          }
        }
      })
    }
    if (selectJob != undefined) {
      selectJob.forEach(x => {
        if (x.length == 0) {
          customJob = "";
        }
        else {
          if (customJob == "") {
            customJob = x.jobTypeName;
          }
          else {
            customJob = customJob.concat(",");
            customJob = customJob.concat(x.jobTypeName);
          }
        }
      })
    }
    if (selectBrand != undefined) {
      selectBrand.forEach(x => {
        if (x.length == 0) {
          customBrand = "";
        }
        else {
          if (customBrand == "") {
            customBrand = x.brandName;
          }
          else {
            customBrand = customBrand.concat(",");
            customBrand = customBrand.concat(x.brandName);
          }
        }
      })
    }
    if (selectCrop != undefined) {
      selectCrop.forEach(x => {
        if (x.length == 0) {
          customCrop = "";
        }
        else {
          if (customCrop == "") {
            customCrop = x.cropName;
          }
          else {
            customCrop = customCrop.concat(",");
            customCrop = customCrop.concat(x.cropName);
          }
        }
      })
    }
    if (selectLanguage != undefined) {
      selectLanguage.forEach(x => {
        if (x.length == 0) {
          customLanguage = "";
        }
        else {
          if (customLanguage == "") {
            customLanguage = x.languageName;
          }
          else {
            customLanguage = customLanguage.concat(",");
            customLanguage = customLanguage.concat(x.languageName);
          }
        }
      })
    }
    if (selectStatus != undefined) {
      selectStatus.forEach(x => {
        if (x.length == 0) {
          customStatus = "";
        }
        else {
          if (customStatus == "") {
            customStatus = x.requirementStatusName;
          }
          else {
            customStatus = customStatus.concat(",");
            customStatus = customStatus.concat(x.requirementStatusName);
          }
        }
      })
    }
    if (selectMonth != undefined) {
      selectMonth.forEach(x => {
        if (x.length == 0) {
          customMonth = "";
        }
        else {
          if (customMonth == "") {
            customMonth = x.item_id;
          }
          else {
            customMonth = customMonth.concat(",");
            customMonth = customMonth.concat(x.item_id);
          }
        }
      })
    }
    if (selectState != undefined) {
      selectState.forEach(x => {
        if (x.length == 0) {
          customState = "";
        }
        else {
          if (customState == "") {
            customState = x.stateName;
          }
          else {
            customState = customState.concat(",");
            customState = customState.concat(x.stateName);
          }
        }
      })
    }
    this.vendorFinalizationService.downloadExcel(customJobNo, customRmh, customJob, customBrand, customCrop,
      customLanguage, customStatus, customMonth, customState, customVendor,customYear)
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
          let Name = localStorage.getItem('mcmt_userName').split(' ');
          let Firstname = Name[0];
          let LastName = Name[1];
          let cYear = this.year.selectedItems[0].id;
          let ExcelName = Firstname + '_' + LastName + '_'+ cYear + '_VendorFinalization_' + latest_date + '.xlsx';
          saveAs(success, ExcelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("Some problem occurred while downloading file.");
          this.loader = 'none';
        }
      );
  }

  updateVendorType() {
    let updateVendorType: UpdateVendorType[] = [];
    let active: number = 0;
    this.loader = 'block';
    this.mainVendorDetails.forEach(detail => {
      if (detail.isActive == true) {
        var approvedVendor = {
          JobNumber: detail.jobNumber,
          VendorType: detail.vendorType
        };
        updateVendorType.push(approvedVendor);
        active = 1;
      }
    })
    if (active == 1) {
      this.vendorFinalizationService.updateVendorType(updateVendorType)
        .subscribe((resdata: any) => {
          if (resdata.status == true) {
            if (resdata.data[0].status == 'true') {
              this.toastr.success(resdata.data[0].msg);
              this.loader = 'none';
              this.vendorFinalizationDetails();
              this.filter();
            } else {
              this.toastr.error('Please save vendor details before finalize');
              this.loader = 'none';
            }
          }
          else {
            this.toastr.error(resdata.msg);
            this.loader = 'none';
          }
        })
    }
    else {
      this.toastr.error('Requirement not selected');
      this.loader = 'none';
    }
  }

  filesAdd(files: File[]) {
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }

    this.loader = 'block';
    this.vendorFinalizationService.uploadVendorFinalization(<File>this.files[0])
      .subscribe((resData: any) => {
        if (resData.status == true) {
          if (resData.data[0].status == 'true') {
            this.toastr.success(resData.data[0].msg);
            this.loader = 'none';
            this.vendorFinalizationDetails();
            this.filter();
            this.input.nativeElement.value = null;
          } else {
            this.toastr.error(resData.data[0].msg);
            this.loader = 'none';
            this.input.nativeElement.value = null;
            this.vendorFinalizationDetails();
            this.filter();
          }
        }
        else {
          this.toastr.error('Some problem occurred, please try again later.');
          this.loader = 'none';
          this.input.nativeElement.value = null;
        }
        this.files = [];
        this.loader = 'none';
      });
    this.files = files;
    this.fileName = files[0].name;
  }

  onYearSelect(item: any) {
    let selectedyear = this.year.selectedItems[0].id;
    
    if(selectedyear != this.vendorFilters.rollingYears[0].currentrequirementYear)
    {     
      var someElement= document.getElementById("ancUploadExcel"); 
      someElement.className += "hideuploadExcel";
    }
    else
    {
      document.getElementById("ancUploadExcel").classList.remove("hideuploadExcel");
    }
  }

  filter() {
    let customRmh: any[] = this.selectedRMHName;
    let customBrand: any[] = this.selectedBrand;
    let customJob: any[] = this.selectedJobType;
    let customCrop: any[] = this.selectedCrop;
    let customLanguage: any[] = this.selectedLanguage;
    let customJobNo: any[] = this.selectedJobNumber;
    let customState: any[] = this.selectedState;
    let customMonth: any[] = this.selectedMonth;
    let customVendor: any[] = this.selectedVendor;
    let customYear: any[] = this.year.selectedItems;
    let filteredRmh = [];
    let filteredBrand = [];
    let filteredCrop = [];
    let filteredJob = [];
    let filteredLanguage = [];
    let filteredWH = [];
    let filteredState = [];
    let filteredMonth = [];
    let filteredVendor = [];
    let filteredVendorDetail: VendorFinalizationDetails[] = this.mainVendorDetails;
    let resultDetail: VendorFinalizationDetails[] = [];
    let resultId = [];
    let splitString: any[] = [];
    let filter: boolean = false;
    if (customRmh != undefined && customRmh.length > 0) {
      customRmh.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.rmhId == element.rMHCode) {
            filteredRmh.push(detail.jobNumber);
          }
        })
      });
      resultId = filteredRmh;
      filter = true;
    }
    if (customBrand != undefined && customBrand.length > 0) {
      customBrand.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.brand == element.brandName) {
            filteredBrand.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredBrand.includes(x))
        }
      }
      else {
        resultId = filteredBrand;
      }
      filter = true;
    }
    if (customYear != undefined && customYear.length > 0) {
      customYear.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.year == element.id) {
            filteredBrand.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredBrand.includes(x))
        }
      }
      else {
        resultId = filteredBrand;
      }
      filter = true;
    }
    if (customCrop != undefined && customCrop.length > 0) {
      customCrop.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.crop == element.cropName) {
            filteredCrop.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredCrop.includes(x))
        }
      }
      else {
        resultId = filteredCrop;
      }
      filter = true;
    }
    if (customJob != undefined && customJob.length > 0) {
      customJob.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.jobType == element.jobTypeName) {
            filteredJob.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredJob.includes(x))
        }
      }
      else {
        resultId = filteredJob;
      }
      filter = true;
    }
    if (customLanguage != undefined && customLanguage.length > 0) {
      customLanguage.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.language == element.languageName) {
            filteredLanguage.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredLanguage.includes(x))
        }
      }
      else {
        resultId = filteredLanguage;
      }
      filter = true;
    }
    if (customJobNo != undefined && customJobNo.length > 0) {
      customJobNo.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.jobNumber == element.jobNumberName) {
            filteredWH.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredWH.includes(x))
        }
      }
      else {
        resultId = filteredWH;
      }
      filter = true;
    }
    if (customVendor != undefined && customVendor.length > 0) {
      customVendor.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.vendorType != null && detail.vendorType.split(',').length > 1) {
            detail.vendorType.split(',').map(elements => {
              if (elements == element.vendorType) {
                filteredVendor.push(detail.jobNumber);
              }
            });
          }
          else {
            if (detail.vendorType == element.vendorType) {
              filteredVendor.push(detail.jobNumber);
            }
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredVendor.includes(x))
        }
      }
      else {
        resultId = filteredVendor;
      }
      filter = true;
    }
    if (customState != undefined && customState.length > 0) {
      customState.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.state == element.stateName) {
            filteredState.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredState.includes(x))
        }
      }
      else {
        resultId = filteredState;
      }
      filter = true;
    }
    if (customMonth != undefined && customMonth.length > 0) {
      customMonth.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          splitString = detail.requirementMonth.split("'");
          if (splitString[0] == element.item_text) {
            filteredMonth.push(detail.jobNumber);
          }
        })
      });
      if (filter == true) {
        if (resultId.length > 0) {
          resultId = resultId.filter(x => filteredMonth.includes(x))
        }
      }
      else {
        resultId = filteredMonth;
      }
      filter = true;
    }
    if (filter == true) {
      resultId.forEach(element => {
        filteredVendorDetail.forEach(detail => {
          if (detail.jobNumber == element) {
            resultDetail.push(detail);
          }
        })
      })
      this.vendorDetails = resultDetail;
    }
    else {
      this.vendorDetails = this.mainVendorDetails;
    }
    this.sortDirection = '';
  }
  onItemSelect() {

  }
  onSelectAll() {

  }

  onItemSelectJob() {
    let jobNo = this.selectedJobNumber;
    let customBrand = [];
    let customRmh = [];
    let customCrop = [];
    let customJob = [];
    let customLanguage = [];
    let customMonth = [];
    let customState = [];
    let customJobNo = [];
    let customVendor = [];
    this.vendorFilters.jobNumbers.forEach(x => {
      jobNo.forEach(element => {
        if (element.jobNumberName == x.jobNumberName) {
          customJobNo.push(x);
        }
      });
    })
    let active: boolean = true;
    this.vendorFilters.brands.forEach(x => {
      customJobNo.forEach(element => {
        if (x.brandID == element.brandID.trim()) {
          if (customBrand.length == 0) {
            customBrand.push(x);
          }
          else {
            customBrand.forEach(y => {
              if (y.brandID == x.brandID) {
                active = false;
              }
            })
            if (active == true) {
              customBrand.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.vendorTypeDetail.forEach(x => {
      customJobNo.forEach(element => {
        if (x.vendorTypeID == element.vendorID) {
          if (customVendor.length == 0) {
            customVendor.push(x);
          }
          else {
            customVendor.forEach(y => {
              if (y.vendorTypeID == x.vendorTypeID) {
                active = false;
              }
            })
            if (active == true) {
              customVendor.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.vendorFilters.states.forEach(x => {
      customJobNo.forEach(element => {
        if (x.stateName == element.stateName) {
          if (customState.length == 0) {
            customState.push(x);
          }
          else {
            customState.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customState.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.vendorFilters.crops.forEach(x => {
      customJobNo.forEach(element => {
        if (x.cropID == element.cropID) {
          if (customCrop.length == 0) {
            customCrop.push(x);
          }
          else {
            customCrop.forEach(y => {
              if (y.cropID == x.cropID) {
                active = false;
              }
            })
            if (active == true) {
              customCrop.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.vendorFilters.jobTypes.forEach(x => {
      customJobNo.forEach(element => {
        if (x.jobTypeID == element.jobTypeID) {
          if (customJob.length == 0) {
            customJob.push(x);
          }
          else {
            customJob.forEach(y => {
              if (y.jobTypeID == x.jobTypeID) {
                active = false;
              }
            })
            if (active == true) {
              customJob.push(x);
            }
            active = true
          }
        }
      });
    })
    this.vendorFilters.languages.forEach(x => {
      customJobNo.forEach(element => {
        if (x.languageID == element.languageID) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.languageID == x.languageID) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      });
    })
    this.vendorFilters.rmhs.forEach(x => {
      customJobNo.forEach(element => {
        if (x.rMHCode == element.rMHCode) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      });
    })
    this.dropdownList.forEach(x => {
      customJobNo.forEach(element => {
        if (x.item_id == element.month) {
          if (customMonth.length == 0) {
            customMonth.push(x);
          }
          else {
            customMonth.forEach(y => {
              if (y.item_id == x.item_id) {
                active = false;
              }
            })
            if (active == true) {
              customMonth.push(x);
            }
            active = true
          }
        }
      });
    })
    this.selectedJobType = customJob;
    this.selectedLanguage = customLanguage;
    this.selectedMonth = customMonth;
    this.selectedRMHName = customRmh;
    this.selectedState = customState;
    this.selectedCrop = customCrop;
    this.selectedBrand = customBrand;
    this.selectedVendor = customVendor;
  }

  onItemSelectState() {
    let customState: any[] = this.selectedState;
    let customRmh = [];
    let finalRMH = [];
    let customLanguage = [];
    let finalLanguage = [];
    let active: boolean = true;
    this.vendorFilters.maMapping.forEach(x => {
      customState.forEach(detail => {
        if (x.stateName == detail.stateName) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      })
    })
    this.vendorFilters.rmhs.forEach(x => {
      customRmh.forEach(detail => {
        if (x.rMHCode == detail.rMHCode) {
          if (finalRMH.length == 0) {
            finalRMH.push(x);
          }
          else {
            finalRMH.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              finalRMH.push(x);
            }
            active = true
          }
        }
      })
    })
    this.vendorFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.state == x.state) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.vendorFilters.languages.forEach(x => {
      customLanguage.forEach(detail => {
        if (x.languageName == detail.languageName) {
          if (finalLanguage.length == 0) {
            finalLanguage.push(x);
          }
          else {
            finalLanguage.forEach(y => {
              if (y.languageName == x.languageName) {
                active = false;
              }
            })
            if (active == true) {
              finalLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.selectedRMHName = finalRMH;
    this.selectedLanguage = finalLanguage;
  }

  onStateDeSelect() {
    this.onItemSelectState()
  }

  onJobDeSelect() {
    this.onItemSelectJob()
  }
  onItemSelectAllJob() {
    let customBrand = [];
    let customRmh = [];
    let customCrop = [];
    let customJob = [];
    let customLanguage = [];
    let customMonth = [];
    let customState = [];
    let customJobNo = [];
    let customVendor = [];
    this.vendorFilters.jobNumbers.forEach(x => {
      customJobNo.push(x);
    })
    let active: boolean = true;
    this.vendorFilters.brands.forEach(x => {
      customJobNo.forEach(element => {
        if (x.brandID == element.brandID) {
          if (customBrand.length == 0) {
            customBrand.push(x);
          }
          else {
            customBrand.forEach(y => {
              if (y.brandID == x.brandID) {
                active = false;
              }
            })
            if (active == true) {
              customBrand.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.vendorTypeDetail.forEach(x => {
      customJobNo.forEach(element => {
        if (x.vendorTypeID == element.vendorID) {
          if (customVendor.length == 0) {
            customVendor.push(x);
          }
          else {
            customVendor.forEach(y => {
              if (y.vendorTypeID == x.vendorTypeID) {
                active = false;
              }
            })
            if (active == true) {
              customVendor.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.vendorFilters.states.forEach(x => {
      customJobNo.forEach(element => {
        if (x.stateName == element.stateName) {
          if (customState.length == 0) {
            customState.push(x);
          }
          else {
            customState.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customState.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.vendorFilters.crops.forEach(x => {
      customJobNo.forEach(element => {
        if (x.cropID == element.cropID) {
          if (customCrop.length == 0) {
            customCrop.push(x);
          }
          else {
            customCrop.forEach(y => {
              if (y.cropID == x.cropID) {
                active = false;
              }
            })
            if (active == true) {
              customCrop.push(x);
            }
            active = true;
          }
        }
      });
    })
    this.vendorFilters.jobTypes.forEach(x => {
      customJobNo.forEach(element => {
        if (x.jobTypeID == element.jobTypeID) {
          if (customJob.length == 0) {
            customJob.push(x);
          }
          else {
            customJob.forEach(y => {
              if (y.jobTypeID == x.jobTypeID) {
                active = false;
              }
            })
            if (active == true) {
              customJob.push(x);
            }
            active = true
          }
        }
      });
    })
    this.vendorFilters.languages.forEach(x => {
      customJobNo.forEach(element => {
        if (x.languageID == element.languageID) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.languageID == x.languageID) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      });
    })
    this.vendorFilters.rmhs.forEach(x => {
      customJobNo.forEach(element => {
        if (x.rMHCode == element.rMHCode) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      });
    })
    this.dropdownList.forEach(x => {
      customJobNo.forEach(element => {
        if (x.item_id == element.month) {
          if (customMonth.length == 0) {
            customMonth.push(x);
          }
          else {
            customMonth.forEach(y => {
              if (y.item_id == x.item_id) {
                active = false;
              }
            })
            if (active == true) {
              customMonth.push(x);
            }
            active = true
          }
        }
      });
    })
    this.selectedJobType = customJob;
    this.selectedLanguage = customLanguage;
    this.selectedMonth = customMonth;
    this.selectedRMHName = customRmh;
    this.selectedState = customState;
    this.selectedCrop = customCrop;
    this.selectedBrand = customBrand;
    this.selectedVendor = customVendor;
  }
  onJobAllDeSelect() {
    this.selectedJobType = [];
    this.selectedLanguage = [];
    this.selectedMonth = [];
    this.selectedRMHName = [];
    this.selectedState = [];
    this.selectedCrop = [];
    this.selectedBrand = [];
    this.selectedVendor = [];
  }
  onItemSelectAllState() {
    let customRmh = [];
    let finalRMH = [];
    let customLanguage = [];
    let finalLanguage = [];
    let customState = [];
    this.vendorFilters.states.forEach(x => {
      customState.push(x);
    })
    let active: boolean = true;
    this.vendorFilters.maMapping.forEach(x => {
      customState.forEach(detail => {
        if (x.stateName == detail.stateName) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.stateName == x.stateName) {
                active = false;
              }
            })
            if (active == true) {
              customRmh.push(x);
            }
            active = true
          }
        }
      })
    })
    this.vendorFilters.rmhs.forEach(x => {
      customRmh.forEach(detail => {
        if (x.rMHCode == detail.rMHCode) {
          if (finalRMH.length == 0) {
            finalRMH.push(x);
          }
          else {
            finalRMH.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              finalRMH.push(x);
            }
            active = true
          }
        }
      })
    })
    this.vendorFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.state == x.state) {
                active = false;
              }
            })
            if (active == true) {
              customLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.vendorFilters.languages.forEach(x => {
      customLanguage.forEach(detail => {
        if (x.languageName == detail.languageName) {
          if (finalLanguage.length == 0) {
            finalLanguage.push(x);
          }
          else {
            finalLanguage.forEach(y => {
              if (y.languageName == x.languageName) {
                active = false;
              }
            })
            if (active == true) {
              finalLanguage.push(x);
            }
            active = true
          }
        }
      })
    })
    this.selectedRMHName = finalRMH;
    this.selectedLanguage = finalLanguage;
  }
  onStateAllDeSelect() {
    this.selectedRMHName = [];
    this.selectedLanguage = [];
  }
  sort() {
    let sortedArray: VendorFinalizationDetails[] = [];
    let splitString: any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownList.forEach(x => {
        this.vendorDetails.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.vendorDetails = sortedArray;
    }
    else {
      this.dropdownList.forEach(x => {
        this.vendorDetails.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.vendorDetails = sortedArray.reverse();
    }
  }

  selectAll() {
    if (this.selected == 0) {
      this.vendorDetails.forEach(element => {
        if (element.orderStatus == "Vendor Finalization Pending") {
          element.isActive = true;
        }
      })
    }
    else {
      this.vendorDetails.forEach(element => {
        if (element.orderStatus == "Vendor Finalization Pending") {
          element.isActive = false;
        }
      })
    }
  }

  check(index: any) {
    if (this.roleID == '51') {
      if (this.vendorDetails[index].orderStatus == "Vendor Finalization Pending") {
        return 'false'
      }
      else {
        return 'true'
      }
    }
  }

  updateIsactive(index: any) {
    let selectedIDCustom = this.vendorDetails[index].jobNumber;
    let selectedIsActive = this.vendorDetails[index].isActive;
    this.mainVendorDetails.forEach(function (detail) {
      if (detail.jobNumber == selectedIDCustom) {
        detail.isActive = selectedIsActive;
      }
    })
  }

  DisplayvendorAssignment(index: any) {
    this.displayVendorAssignment = 'block';    
    const body = document. getElementsByTagName('body')[0];
    body. classList. add('overlay-back');
    this.displayViewAssesment = 'block';
    this.VendorFinalizationpopUp = [];
    this.VendorJobNumber = this.vendorDetails[index].jobNumber;
    this.IsValidForDelete = 'block';
    this.Vendordetails(0, this.VendorJobNumber, 0, '', 0, 0, 'SELECT');
  }
  viewvendorAssignment(index: any) {
    this.VendorFinalizationpopUp = [];    
    const body = document. getElementsByTagName('body')[0];
    body. classList. add('overlay-back');
    this.displayVendorAssignment = 'block';
    this.VendorJobNumber = this.vendorDetails[index].jobNumber;
    this.IsValidForDelete = 'none';
    this.displayViewAssesment = 'none';
    this.Vendordetails(0, this.VendorJobNumber, 0, '', 0, 0, 'SELECT');
  }
  closePanel() {
    this.displayVendorAssignment = 'none';
    this.VendorFinalizationpopUp = []; 
    this.IsSave='block';
    this.IsEdit='none';
    this.vendorType='';
    const body = document. getElementsByTagName('body')[0];
    body. classList. remove('overlay-back');
  }
  Savevendor() {
    let vendorName = this.vendorTypeDetail.find(m => m.vendorTypeID == this.vendorType).vendorType;
    this.vendorFinalizationService.updateVendorTypeDetails(0, this.VendorJobNumber, this.vendorType, vendorName, 3, 1, 'INSERT')
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.vendorGridTypeDetail = resData.data;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }
EditVendor(index: number)
{
this.vendorType=this.vendorTypeDetail.find(m => m.vendorType == this.vendorGridTypeDetail[index].vendorName).vendorTypeID;
this.IsSave='none';
this.IsEdit='block';
this.editIndex=index;
}

  UpdateVendor() {
    this.Vendordetails(this.vendorGridTypeDetail[this.editIndex].id, this.vendorGridTypeDetail[this.editIndex].jobNumber, this.vendorTypeDetail.find(m => m.vendorTypeID==this.vendorType).vendorTypeID,  this.vendorTypeDetail.find(m => m.vendorTypeID==this.vendorType).vendorType, 3, 1, 'UPDATE');
    this.IsSave='block';
    this.IsEdit='none';
  }
  Vendordetails(ID: number, jobNumber: string, vendorType: number, vendorName: string, currentStatus: number, isActive: number, action: string) {
    this.vendorFinalizationService.updateVendorTypeDetails(ID, jobNumber, vendorType, vendorName, currentStatus, isActive, action)
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.vendorGridTypeDetail = resData.data;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  ConvertToCurrency(value:any)
  {
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}
